import axiosInstance from "../../axios";
import { GET_RISK_SCENARIOS_REQUEST } from "../types/riskScenariosTypes";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";

export const getRiskScenariosRequest = (risk_scenarios) => {
  return {
    type: GET_RISK_SCENARIOS_REQUEST,
    payload: risk_scenarios,
  };
};

export const fetchRiskScenarios = (orgaId) => {
  return async (dispatch) => {
    dispatch(requestStarted("risk_scenarios"));

    try {
      const res = await axiosInstance.get(`/survey/risk_scenarios/${orgaId}`);
      const data = res.data;
      //   console.log("Fetched risk scenarios:", data?.risk_scenarios);
      dispatch(getRiskScenariosRequest(data?.risk_scenarios));
      dispatch(requestSucceeded());
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
